export default __webpack_public_path__ + "static/media/AngsanaNew.c943d7d1.woff2";